export const TERMINATION_LOADING = "TERMINATION_LOADING";
export const TERMINATION_RESET = "TERMINATION_RESET";
export const GET_TERMINATION = "GET_TERMINATION";
export const GET_TERMINATION_SUCCESS = "GET_TERMINATION_SUCCESS";
export const GET_TERMINATION_FAIL = "GET_TERMINATION_FAIL";
export const DELETE_TERMINATION = "DELETE_TERMINATION"
export const DELETE_TERMINATION_SUCCESS = "DELETE_TERMINATION_SUCCESS"
export const DELETE_TERMINATION_FAIL = "DELETE_TERMINATION_FAIL"
export const UPDATE_TERMINATION = "UPDATE_TERMINATION"
export const UPDATE_TERMINATION_SUCCESS = "UPDATE_TERMINATION_SUCCESS"
export const UPDATE_TERMINATION_FAIL = "UPDATE_TERMINATION_FAIL"
export const ADD_NEW_TERMINATION = "ADD_NEW_TERMINATION"
export const ADD_TERMINATION_SUCCESS = "ADD_TERMINATION_SUCCESS"
export const ADD_TERMINATION_FAIL = "ADD_TERMINATION_FAIL"